import { Icon } from '@/components/core';

import styles from './LoadingSpinner.module.scss';

type LoadingSpinnerProps = {};

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = () => (
    <Icon
        name="spinner"
        className={styles.root}
    />
);
